import Icon from '~/components/customer/icon.vue'
import Call from '~/components/customer/call.vue'

import Form from '~/components/customer/input/form.vue'
import InputText from '~/components/customer/input/input.vue'
import InputTextArea from '~/components/customer/input/textarea.vue'
import InputAddress from '~/components/customer/input/address.vue'
import InputError from '~/components/customer/input/error.vue'
import InputCheckboxSelectableWrap from '~/components/customer/input/checkbox-selectable-wrap.vue'
import InputCheckboxSelectableImagesGrid from '~/components/customer/input/checkbox-selectable-images-grid.vue'
import ButtonSaving from '~/components/customer/input/button-saving.vue'
import Select from '~/components/customer/input/select.vue'
import InputToggle from '~/components/customer/input/toggle.vue'
import DateInput from '~/components/customer/input/date-input.vue'
import Dropdown from '~/components/customer/input/dropdown.vue'
import DropdownV2 from '~/components/customer/input/dropdown-v2.vue'
import ShowMore from '~/components/customer/input/show-more.vue'
import Tooltip from '~/components/customer/input/tooltip.vue'
import Collapse from '~/components/customer/input/collapse.vue'
import InputCheckbox from '~/components/customer/input/checkbox.vue'
import InputDatePicker from '~/components/customer/input/date-picker.vue'
import InputDropdownDatePicker from '~/components/customer/input/dropdown-date-picker.vue'
import Empty from '~/components/customer/blocks/empty.vue'
import ButtonCRM from '~/components/customer/input/crm-button.vue'
import SelectCard from '~/components/customer/input/select-card.vue'

import ZapGenerated from '~/components/customer/blocks/zap-generated.vue'

import TablePage from '~/components/customer/table/table-page.vue'
import Th from '~/components/customer/table/th.vue'
import Td from '~/components/customer/table/td.vue'

import GridTabs from '~/components/customer/tabs/grid-tabs.vue'
import Tab from '~/components/customer/tabs/tab.vue'
import Tabs from '~/components/customer/tabs/tabs.vue'

import TransitionHeight from '~/components/customer/transition-height.vue'

import ModalTemplate from '~/components/customer/modals/modal-template.vue'
import Modal from '~/components/customer/modals/modal.vue'
// import ModalEventView from '~/components/customer/modals/view-event.vue'
import ModalCreateAll from '~/components/customer/modals/create-anything.vue'
import ModalFormCard from '~/components/customer/modals/elements/modal-form-card.vue'

import Timeline from '~/components/customer/timeline/timeline.vue'
// import TimelineCard from '~/components/customer/timeline/elements/card.vue'

import Temperature from '~/components/customer/blocks/temprature.vue'
import PaymentMethodTable from '~/components/customer/blocks/payment-method-table.vue'
import PaymentMethodCard from '~/components/customer/blocks/payment-method.vue'
import CustomerSettingsNav from '~/components/customer/blocks/customer-settings-nav.vue'

import BelongsContactDeal from '~/components/customer/belongs/contact-deal.vue'

import Stripe from '~/components/customer/stripe/stripe.vue'

import FilePreview from '~/components/customer/blocks/file-preview.vue'

import Loader from '~/components/customer/blocks/loader.vue'

// import VTooltip from 'v-tooltip'
// import Tooltip from "~/directives/tooltip.js";
import VueTippy from 'vue-tippy'
import 'tippy.js/dist/tippy.css'

// import Gleap from 'gleap';
import VueIntercom from '@homebaseai/vue3-intercom'
// import TrustpilotPlugin from "vue-trustpilot";
import VueConfetti from 'vue-confetti'

import VueCountdown from '@chenfengyuan/vue-countdown'

// import LayoutDefault from '~/components/admin/layouts/default.vue'
import Grid12 from '~/components/admin/layouts/grid-12.vue'

export default defineNuxtPlugin({
	name: 'load-components',
	parallel: true,
	async setup(nuxtApp) {
		// Gleap.initialize("SqYSD3fuKL9qNBe3nvAB2wtxNBoEVLMS");

		nuxtApp.vueApp.component('Icon', Icon)
		nuxtApp.vueApp.component('Call', Call)
		nuxtApp.vueApp.component('Form', Form)
		nuxtApp.vueApp.component('Input', InputText)
		nuxtApp.vueApp.component('Textarea', InputTextArea)
		nuxtApp.vueApp.component('Select', Select)
		nuxtApp.vueApp.component('Error', InputError)
		nuxtApp.vueApp.component('Toggle', InputToggle)
		nuxtApp.vueApp.component('InputCheckbox', InputCheckbox)
		nuxtApp.vueApp.component('InputDatePicker', InputDatePicker)
		nuxtApp.vueApp.component('InputDropdownDatePicker', InputDropdownDatePicker)
		nuxtApp.vueApp.component('InputAddress', InputAddress)
		nuxtApp.vueApp.component('InputCheckboxSelectableWrap', InputCheckboxSelectableWrap)
		nuxtApp.vueApp.component('InputCheckboxSelectableImagesGrid', InputCheckboxSelectableImagesGrid)
		nuxtApp.vueApp.component('ButtonSaving', ButtonSaving)
		nuxtApp.vueApp.component('DateInput', DateInput)
		nuxtApp.vueApp.component('Dropdown', Dropdown)
		nuxtApp.vueApp.component('DropdownV2', DropdownV2)
		nuxtApp.vueApp.component('ShowMore', ShowMore)
		nuxtApp.vueApp.component('Tooltip', Tooltip)
		nuxtApp.vueApp.component('TablePage', TablePage)
		nuxtApp.vueApp.component('Th', Th)
		nuxtApp.vueApp.component('Td', Td)
		nuxtApp.vueApp.component('GridTabs', GridTabs)
		nuxtApp.vueApp.component('Tab', Tab)
		nuxtApp.vueApp.component('Tabs', Tabs)
		nuxtApp.vueApp.component('Empty', Empty)
		nuxtApp.vueApp.component('TransitionHeight', TransitionHeight)
		nuxtApp.vueApp.component('ModalTemplate', ModalTemplate)
		nuxtApp.vueApp.component('Modal', Modal)
		nuxtApp.vueApp.component('ModalFormCard', ModalFormCard)
		nuxtApp.vueApp.component('Timeline', Timeline)
		// nuxtApp.vueApp.component('TimelineCard', TimelineCard)
		nuxtApp.vueApp.component('Temperature', Temperature)
		nuxtApp.vueApp.component('PaymentMethodTable', PaymentMethodTable)
		nuxtApp.vueApp.component('PaymentMethodCard', PaymentMethodCard)
		nuxtApp.vueApp.component('CustomerSettingsNav', CustomerSettingsNav)
		nuxtApp.vueApp.component('Collapse', Collapse)
		nuxtApp.vueApp.component('ButtonCRM', ButtonCRM)
		nuxtApp.vueApp.component('SelectCard', SelectCard)

		nuxtApp.vueApp.component('BelongsContactDeal', BelongsContactDeal)

		nuxtApp.vueApp.component('ModalCreateAll', ModalCreateAll)

		nuxtApp.vueApp.component('Stripe', Stripe)

		nuxtApp.vueApp.component('FilePreview', FilePreview)

		nuxtApp.vueApp.component('ZapGenerated', ZapGenerated)

		nuxtApp.vueApp.component('Countdown', VueCountdown)

		nuxtApp.vueApp.component('Loader', Loader)

		nuxtApp.vueApp.use(VueTippy, {
			defaultProps: {
				theme: 'dark',
				delay: 200,
				touch: false,
				// arrow: true,
				// showOnCreate: true,
				maxWidth: '220px',
				offset: [0, 16],
			},
		})

		nuxtApp.vueApp.use(VueIntercom)

		nuxtApp.vueApp.use(VueConfetti)

		nuxtApp.vueApp.component('Grid12', Grid12)
	},

	// nuxtApp.vueApp.use(TrustpilotPlugin, {
	//     widgets: {
	//         footer: {
	//             templateId: "5406e65db0d04a09e042d5fc",
	//             businessunitId: "5dde7b1cd5594d0001d706fa",
	//             reviewUrl: "https://uk.trustpilot.com/review/getwork.co.uk",
	//             locale: "en-GB",
	//             theme: 'light',
	//             styleHeight: '28px',
	//             styleWidth: '85%'
	//         }
	//     }
	// });
})
